import {getSafeRedirectUrl} from '../../../lib/safeRedirectUrl'

const DEFAULT_AUTH_REDIRECT_URL = '/home'

export function buildAuthHref(authPath: string, redirectUrl: string | undefined): string {
    const safeRedirectUrl = getSafeRedirectUrl(redirectUrl, DEFAULT_AUTH_REDIRECT_URL)
    return `${authPath}?redirect_url=${encodeURIComponent(safeRedirectUrl)}`
}

const EMBED_SOURCE_PARAM = 'zrodlo'
const EMBED_SOURCE_VALUE = 'widget'

/** Marks a link leaving the website widget, so the Studio page it opens can count the visit. */
export function withEmbedSource(href: string): string {
    return `${href}${href.includes('?') ? '&' : '?'}${EMBED_SOURCE_PARAM}=${EMBED_SOURCE_VALUE}`
}

// The page a visitor opened from the widget; remembered because the mark leaves the address once read.
let embedVisitPath: string | null = null

/**
 * Whether the current page was opened from the website widget. The mark is removed from the address
 * on first read, so a reload or a shared link does not count the visit again.
 */
export function isEmbedSourceVisit(): boolean {
    const url = new URL(window.location.href)
    if (url.searchParams.get(EMBED_SOURCE_PARAM) === EMBED_SOURCE_VALUE) {
        embedVisitPath = url.pathname
        url.searchParams.delete(EMBED_SOURCE_PARAM)
        window.history.replaceState(window.history.state, '', url)
    }
    // Leaving that page ends the visit; coming back later is not another visit from the widget.
    if (embedVisitPath !== window.location.pathname) embedVisitPath = null
    return embedVisitPath !== null
}
